import { cx } from '@/lib/cx'
import type { NominationImage } from '@/nominations/types'

type NominationAvatarProps = {
  monogram: string
  photo?: NominationImage
  size?: 'sm' | 'md' | 'lg'
  onDark?: boolean
}

/** Circular portrait. Grayscale photo when one exists, serif monogram on navy otherwise. */
export const NominationAvatar = ({ monogram, photo, size = 'md', onDark = false }: NominationAvatarProps) => {
  const className = cx('nom-avatar', `nom-avatar--${size}`, onDark && 'nom-avatar--on-dark')

  if (photo) {
    return <img className={className} src={photo.src} alt={photo.alt} loading="lazy" decoding="async" />
  }

  return (
    <span className={cx(className, 'nom-avatar--monogram')} aria-hidden>
      {monogram}
    </span>
  )
}
